<template>
    <div>
        <kt-form-section class="mb-5 mt-3">
            <kt-form-label>
                <h4>
                    {{ $t('customers_club.setting.percent') }}
                </h4>
            </kt-form-label>
            <kt-row>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_level_1">
                            {{ $t('customers_club.setting.reduction_percent') + $t('customers_club.setting.level_1') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_level_1"
                                id="wage_plan_ivr_percent_level_1"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_level_1"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_level_2">
                            {{ $t('customers_club.setting.reduction_percent') + $t('customers_club.setting.level_2') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_level_2"
                                id="wage_plan_ivr_percent_level_2"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_level_2"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_level_3">
                            {{ $t('customers_club.setting.reduction_percent') + $t('customers_club.setting.level_3') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_level_3"
                                id="wage_plan_ivr_percent_level_3"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_level_3"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_max_reduction_level_1">
                            {{
                                $t('customers_club.setting.reduction_maximum_amount') + $t('customers_club.setting.lev_1')
                            }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_max_reduction_level_1"
                                id="wage_plan_ivr_percent_max_reduction_level_1"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_max_reduction_level_1"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_max_reduction_level_2">
                            {{
                                $t('customers_club.setting.reduction_maximum_amount') + $t('customers_club.setting.lev_2')
                            }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_max_reduction_level_2"
                                id="wage_plan_ivr_percent_max_reduction_level_2"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_max_reduction_level_2"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_max_reduction_level_3">
                            {{
                                $t('customers_club.setting.reduction_maximum_amount') + $t('customers_club.setting.lev_3')
                            }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_max_reduction_level_3"
                                id="wage_plan_ivr_percent_max_reduction_level_3"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_max_reduction_level_3"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_max_reduction_level_1">
                            {{
                                $t('customers_club.setting.reduction_minimum_amount') + $t('customers_club.setting.lev_1')
                            }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_max_reduction_level_1"
                                id="wage_plan_ivr_percent_max_reduction_level_1"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_min_reduction_level_1"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_max_reduction_level_2">
                            {{
                                $t('customers_club.setting.reduction_minimum_amount') + $t('customers_club.setting.lev_2')
                            }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_max_reduction_level_2"
                                id="wage_plan_ivr_percent_max_reduction_level_2"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_min_reduction_level_2"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_percent_max_reduction_level_3">
                            {{
                                $t('customers_club.setting.reduction_minimum_amount') + $t('customers_club.setting.lev_3')
                            }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_percent_max_reduction_level_3"
                                id="wage_plan_ivr_percent_max_reduction_level_3"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_percent_min_reduction_level_3"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-section class="mb-5 mt-3">
            <kt-form-label>
                <h4>
                    {{ $t('customers_club.setting.constant') }}
                </h4>
            </kt-form-label>
            <kt-row>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_constant_level_1">
                            {{ $t('customers_club.setting.reduction_amount') + $t('customers_club.setting.lev_1') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_constant_level_1"
                                id="wage_plan_ivr_constant_level_1"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_constant_level_1"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_constant_level_2">
                            {{ $t('customers_club.setting.reduction_amount') + $t('customers_club.setting.lev_2') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_constant_level_2"
                                id="wage_plan_ivr_constant_level_2"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_constant_level_2"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_constant_level_3">
                            {{ $t('customers_club.setting.reduction_amount') + $t('customers_club.setting.lev_3') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_constant_level_3"
                                id="wage_plan_ivr_constant_level_3"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_constant_level_3"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-section class="mb-5 mt-3">
            <kt-form-label>
                <h4>
                    {{ $t('customers_club.setting.periodic') }}
                </h4>
            </kt-form-label>
            <kt-row>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_periodic_level_1">
                            {{ $t('customers_club.setting.reduction_amount') + $t('customers_club.setting.lev_1') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_periodic_level_1"
                                id="wage_plan_ivr_periodic_level_1"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_periodic_level_1"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_periodic_level_2">
                            {{ $t('customers_club.setting.reduction_amount') + $t('customers_club.setting.lev_2') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_periodic_level_2"
                                id="wage_plan_ivr_periodic_level_2"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_periodic_level_2"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-md-4 col-sm-4">
                    <kt-form-group>
                        <kt-form-label for="wage_plan_ivr_periodic_level_3">
                            {{ $t('customers_club.setting.reduction_amount') + $t('customers_club.setting.lev_3') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="wage_plan_ivr_periodic_level_3"
                                id="wage_plan_ivr_periodic_level_3"
                                v-model="customers_club_setting.ivr.wage_plan_ivr_periodic_level_3"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
    </div>
</template>

<script>
export default {
    name: "wage-plan",
    props: {
        customers_club_setting: {
            required: true
        },
    },
}
</script>

<style scoped>

</style>